<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <router-link :to="{ name: 'settings_filter' }">
          <font-awesome-icon :icon="['fas', 'filter']"
        /></router-link>
        <font-awesome-icon :icon="['fas', 'balance-scale']" />
        <span class="title"
          >Object filter by distance and frames: traffic participant or
          not?</span
        >
      </Header>
      <v-row>
        <v-col class="col-12">
          <v-card flat color="transparent">
            <v-card-text>
              <v-row class="rowbox">
                <v-col class="col-5">
                  <v-subheader>Frames per object</v-subheader>
                  <v-range-slider
                    v-model="range1"
                    :max="max"
                    :min="min"
                    class="align-center"
                    @change="ApiGet(false)"
                  >
                    <template v-slot:prepend>
                      <v-text-field
                        :value="range1[0]"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                      ></v-text-field>
                    </template>
                    <template v-slot:append>
                      <v-text-field
                        :value="range1[1]"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                      ></v-text-field>
                    </template>
                  </v-range-slider>
                </v-col>
                <v-col class="col-5">
                  <v-subheader>Distance</v-subheader>
                  <v-range-slider
                    v-model="range2"
                    :max="max2"
                    :min="min2"
                    class="align-center"
                    @change="ApiGet(0)"
                  >
                    <template v-slot:prepend>
                      <v-text-field
                        :value="range2[0]"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                      ></v-text-field>
                    </template>
                    <template v-slot:append>
                      <v-text-field
                        :value="range2[1]"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                      ></v-text-field>
                    </template>
                  </v-range-slider>
                </v-col>
                <v-col class="col-2"
                  ><br /><br />
                  <BaseButton
                    @click.native="
                      copySettings(
                        'field_fpo',
                        range1[0],
                        'field_distance',
                        range2[0]
                      )
                    "
                    >Copy settings</BaseButton
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-12">
          <v-card flat color="transparent">
            <v-card-text>
              <v-row class="rowbox">
                <v-col class="col-3">
                  <div class="xsettings-tekst">
                    <b>Detect non-moving objects</b>
                    <br />
                    <li>Choose distance and fpo interval</li>
                    <li>You get random objects (max 50)</li>
                  </div>
                </v-col>
                <v-col class="col-3">
                  <p style="background-color:yellow">
                    Road users or non-checked objects: {{ this.n_traffic }}
                  </p>
                </v-col>
                <v-col class="col-3">
                  <p style="background-color:lightblue">
                    No road users: {{ this.n_nontraffic }}
                  </p>
                </v-col>
                <v-col class="col-3">
                  <p
                    style="background-color: yellow;background-image: linear-gradient(to right, yellow, lightblue);"
                  >
                    Percentage no road users:
                    {{
                      Math.round(
                        (100 * this.n_nontraffic) /
                          (this.n_traffic + this.n_nontraffic)
                      )
                    }}%
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <div
        id="scroll-target"
        style="max-height: 520px;"
        class="overflow-y-auto"
      >
        <v-row
          class="maps"
          v-scroll:#scroll-target="onScroll"
          align="center"
          justify="center"
          style="width:1250px"
        >
          <v-col class="col-12">
            <div
              :id="'mapdiv[' + indextd + ']'"
              class="mapclassdiv"
              v-for="indextd in this.n_blocks"
              :key="indextd"
              @click="clickimage(indextd)"
            >
              <div class="summary" :id="'summary[' + indextd + ']'">
                {{ summary[indextd] }}
              </div>
              <div class="mapmap" :id="'map[' + indextd + ']'"></div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-app>
</template>
<script>
//@change="$set(range1, 1, $event)" 2x
//@change="$set(range2, 1, $event)"

import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
import BaseButton from "@/components/BaseButton.vue";

import Map from "ol/Map";
import View from "ol/View";
import "ol/ol.css";
import { Vector as VectorSource } from "ol/source";
import ImageLayer from "ol/layer/Image";
import { Vector as VectorLayer } from "ol/layer";
import { Fill, Stroke, Style, Text } from "ol/style";
import GeoJSON from "ol/format/GeoJSON";
import Static from "ol/source/ImageStatic";
import Projection from "ol/proj/Projection";
import { getCenter } from "ol/extent";
var vectorsource;
var vectorlayer;
var extent = [0, 0, 720, 480];
var projection = new Projection({
  code: "static-image",
  units: "pixels",
  extent: extent
});
var style = new Style({
  fill: new Fill({
    color: "rgba(255, 0, 0, 0.1)"
  }),
  stroke: new Stroke({
    color: "#FF0000",
    width: 2
  }),
  text: new Text({
    font: "30px Calibri,sans-serif",
    fill: new Fill({
      color: "#0000ff"
    }),
    stroke: new Stroke({
      color: "#0000ff",
      width: 2
    })
  })
});
export default {
  components: {
    Header,
    BaseButton: BaseButton
  },
  data: function() {
    return {
      routes: {},
      objects: {},
      object: {},
      map: null,
      n_traffic: 0,
      n_nontraffic: 0,
      min: 1,
      max: 110,
      start_optie: 1,
      min2: 0,
      max2: 1000,
      stats: {},
      slider: 40,
      n_blocks: 50,
      range1: [],
      range2: [],
      summary: [],
      width: 256,
      height: 0.666666 * 216 + 20,
      zoom: 0
    };
  },
  computed: {
    cssVars() {
      return {
        "--width": this.width + "px",
        "--height": this.height + "px"
      };
    }
  },
  created() {
    //    this.ApiGetRanges();
  },
  mounted() {
    this.ApiGet(1);
  },

  methods: {
    ApiGet(start) {
      //console.log("ApiGet");
      let vars = {
        range1: this.range1,
        start_optie: start,
        range2: this.range2
      };
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "settings_filter_moving",
        vars
      })
        .then(response => {
          if (start == 1) {
            this.range1 = [
              response.data.fields.field_fpo,
              parseInt(response.data.fields.field_fpo) + 10
            ];
            this.range2 = [
              response.data.fields.field_distance,
              parseInt(response.data.fields.field_distance) + 10
            ];
          }
          this.objects = response.data["data"];
          this.stats = this.objects[0];
          this.n_traffic = this.stats.n_check;
          if (this.n_traffic > 0) {
            this.summary = response.data["summary"];
            this.n_traffic = this.stats.n_check;
            this.n_nontraffic = 0;
            for (var j = 1; j <= this.n_blocks; j++) {
              let el1 = document.getElementById("mapdiv[" + j + "]");
              let el2 = document.getElementById("map[" + j + "]");
              el2.innerHTML = "";
              if (j <= this.stats.n_check) {
                el1.style.display = "inline-block";
                el1.style.backgroundColor = "yellow";
                this.changeObject(j);
              } else {
                el1.style.display = "none";
              }
            }
          } else {
            let message = {
              title: "No records found!"
            };
            this.$dialog.alert(message);
          }
        })
        .catch(error => {
          console.log("!Fout " + error.response);
        });
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    clickimage(nr) {
      let el = document.getElementById("mapdiv[" + nr + "]");
      if (
        !el.style.backgroundColor ||
        el.style.backgroundColor == "lightblue"
      ) {
        el.style.backgroundColor = "yellow";
        this.n_traffic++;
        this.n_nontraffic--;
      } else {
        el.style.backgroundColor = "lightblue";
        this.n_traffic--;
        this.n_nontraffic++;
        this.n_check_moving--;
      }
    },
    copySettings(field, value, field2, value2) {
      console.log("copySettings!");
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "update_fields",
        field,
        value,
        field2,
        value2
      });
      this.$router.push({ name: "settings_filter" });
    },
    changeObject(o_slider) {
      this.object = this.objects[o_slider];
      var graph_id = this.object.obj;
      var show_id = this.object.frame;
      vectorsource = new VectorSource({
        format: new GeoJSON(),
        url:
          "https://trafficdistillery.com/tracking/getmosaicgraph/" +
          this.$session.get("PROJID") +
          "/" +
          graph_id
      });
      var image = new ImageLayer({
        source: new Static({
          url:
            "https://trafficdistillery.com/sites/default/files/project/" +
            this.$session.get("PROJID") +
            "/images/" +
            show_id +
            ".jpg",
          projection: projection,
          size: [this.width, this.height],
          imageExtent: extent
        })
      });
      vectorlayer = new VectorLayer({
        source: vectorsource,
        style: function(feature) {
          style.getText().setText(feature.get("label"));
          return style;
        }
      });
      var map = new Map({
        layers: [image, vectorlayer],
        interactions: [],
        controls: [],
        view: new View({
          controls: [],
          interactions: [],
          projection: projection,
          center: getCenter(extent),
          zoom: this.zoom,
          attribution: false
        })
      });
      map.setTarget("map[" + o_slider + "]");
    }
  }
};
</script>

<style scoped>
.mapclassdiv {
  height: 189px;
  width: 256px;
  margin-left: 22px;
  margin-right: 12px;
  margin-bottom: 5px;
}
.mapmap {
  height: 166px;
  width: 256px;
  display: inline-block;
}
.summary {
  font-size: 0.9em;
  display: inline-block;
  width: 100%;
}
.align-center {
  border-style: solid;
  border-width: thin;
}
.toel {
  font-size: 0.7em;
}
.settings-tekst li {
  display: none;
}
</style>
